import { useCallback, useEffect, useState } from 'react';

import { ConversationBasic } from '@web/conversations/types/Conversation';
import { usePinConversation } from '@web/conversations/hooks/usePinConversation';
import { useUnpinConversation } from '@web/conversations/hooks/useUnpinConversation';

export const useTogglePinConversation = () => {
  const { mutate: pin } = usePinConversation();
  const { mutate: unpin } = useUnpinConversation();

  return useCallback(
    ({ id, isPinned }: ConversationBasic) => {
      isPinned ? unpin({ id }) : pin({ id });
    },
    [pin, unpin]
  );
};

export const useListHeightObserver = () => {
  const [ref, setRef] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!ref) return;

    const updateListContentHeight = () => {
      // always make sure it's the top-most component element
      const groupRootElement = ref.parentNode as HTMLElement;
      // @INFO use CSS var to do not require react to re-render component,
      // while it can be handler strictly by built-in browser mechanisms
      groupRootElement.style.setProperty('--listContentHeight', `${ref.scrollHeight}px`);
    };
    updateListContentHeight();

    const observer = new MutationObserver(updateListContentHeight);
    observer.observe(ref, { attributes: false, childList: true, subtree: false });

    return () => observer.disconnect();
  }, [ref]);

  return setRef;
};
